import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { collection, query, where, getDocs, deleteDoc } from 'firebase/firestore';
import { db } from '../config/firebase'; // Import the db instance
import Post from '../components/Post';
import { Loader2 } from 'lucide-react';

const PostView = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/api/posts/${postId}`);
        setPost(response.data);
      } catch (error) {
        console.error('Error fetching post:', error);
        setError('Failed to load post. The post might have been deleted or is unavailable.');
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [postId]);

  const handlePostUpdate = async () => {
    try {
      const response = await axios.get(`http://localhost:5000/api/posts/${postId}`);
      setPost(response.data);
    } catch (error) {
      console.error('Error updating post:', error);
    }
  };

  const deletePostAndNotifications = async () => {
    try {
      // Delete the post from the database
      await axios.delete(`http://localhost:5000/api/posts/${postId}`);
      
      // Delete associated notifications
      const notificationsRef = collection(db, 'notifications');
      const q = query(notificationsRef, where('postId', '==', postId));
      const snapshot = await getDocs(q);
      
      snapshot.forEach(async (doc) => {
        await deleteDoc(doc.ref);
      });

      navigate('/'); // Redirect after deletion
    } catch (error) {
      console.error('Error deleting post and notifications:', error);
    }
  };


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <Loader2 className="w-8 h-8 text-purple-500 animate-spin" />
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
        <p className="text-gray-400 mb-4">{error || 'Post not found'}</p>
        <button
          className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          onClick={() => navigate('/')}
        >
          Back to Home
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      <div className="max-w-2xl mx-auto">
        <Post
          post={post}
          onLike={handlePostUpdate}
          onDelete={deletePostAndNotifications}
          onBookmark={handlePostUpdate}
        />
      </div>
    </div>
  );
};

export default PostView;
